import {TableColumn} from '../../shared/table-column';

export abstract class AbstractEditor {

    public abstract onEdit(event: any, column: TableColumn, entity: object): void;
    public abstract isEditFinished(event: any, column: TableColumn, entity: object): boolean;

}
